var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addBtn"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.push(_vm.path)}}},[_vm._v("\n        +"+_vm._s(_vm.name)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }